module.exports = __webpack_public_path__ + "img/illustration_1.409cf9c4.png";